<template>
  <div>
    <div class="md-layout">
      <h3 class="md-layout-item md-size-100 mb-5 title font-medium text-2xl">
        {{ $t("academic_plan.academic_plan") }}
      </h3>
      <div class="md-layout-item md-size-40 md-small-size-70">
        <md-field>
          <label :for="select.name">{{ select.label }}</label>
          <md-select
            v-model="programId"
            :name="select.name"
            :id="select.name"
            :multiple="select.multiple"
            @md-selected="selectProgram"
          >
            <md-option
              v-for="option in select.options"
              :value="option.id"
              :key="option.id + option.name"
              >{{ option.name }}
            </md-option>
          </md-select>
        </md-field>
      </div>
      <div class="md-layout-item md-size-100">
        <p class="text-base font-medium">
          {{
            $t("academic_plan.here_you_can_track_the_students_path_graduation")
          }}
        </p>
      </div>
      <div class="md-layout-item md-size-100">
        <md-card class="card-content mt-10">
          <md-card-header class="md-card-header-text md-card-header-green">
            <div class="card-text">
              <h4 class="title text-lg">{{ programName }}</h4>
            </div>
          </md-card-header>
          <md-card-content>
            <md-table>
              <md-table-row>
                <md-table-head class="w-40vw">
                  <span class="font-medium ">{{
                    $t("academic_plan.graduation_category")
                  }}</span>
                </md-table-head>
                <md-table-head>
                  <span class="font-medium ">{{
                    $t("academic_plan.needed")
                  }}</span>
                </md-table-head>
                <md-table-head>
                  <span class="font-medium ">{{
                    $t("academic_plan.earned")
                  }}</span>
                </md-table-head>
                <md-table-head>
                  <span class="font-medium ">{{
                    $t("academic_plan.missing")
                  }}</span>
                </md-table-head>
              </md-table-row>

              <template v-if="infoForm.list">
                <md-table-row
                  v-for="(item, index) in infoForm.list"
                  :key="index"
                >
                  <md-table-cell>{{ item.name }}</md-table-cell>
                  <md-table-cell>{{ item.needed }} </md-table-cell>
                  <md-table-cell>{{ item.earned }}</md-table-cell>
                  <md-table-cell>
                    <span :class="setColor(item.missing)">
                      {{ item.missing }}
                    </span>
                  </md-table-cell>
                </md-table-row>
              </template>

              <template v-if="infoForm.total">
                <md-table-row class="border-top-1">
                  <md-table-head class="w-40vw">
                    <span class="font-medium">{{ $t("common.total") }}</span>
                  </md-table-head>
                  <md-table-head>
                    <span class="font-medium">
                      {{ infoForm.total.needed }}
                    </span>
                  </md-table-head>
                  <md-table-head>
                    <span class="font-medium">
                      {{ infoForm.total.earned }}
                    </span>
                  </md-table-head>
                  <md-table-head>
                    <span
                      :class="setColor(infoForm.total.missing)"
                      class="font-medium"
                    >
                      {{ infoForm.total.missing }}
                    </span>
                  </md-table-head>
                </md-table-row>
              </template>
            </md-table>
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>

<script>
import { service_paths } from "@/constants/Services";
import { mapGetters, mapState } from "vuex";
import Role from "@/constants/Role";
import { hasValidRole } from "@/helpers/role-helper";

export default {
  data() {
    return {
      infoForm: {},
      programs: [],
      programId: null,
      programName: "",
      isFirstLoaded: false,
      select: {
        label: this.$t("program.filter_by_name"),
        name: "program__",
        value: "",
        type: "select",
        options: []
      }
    };
  },
  computed: {
    ...mapGetters("user", {
      userInfo: "info"
    }),
    ...mapGetters("user", ["role"]),
    ...mapState("switchAccountChild", ["currentChild"])
  },
  created() {
    if (this.userInfo) {
      this.getDefaultProgram(this.userInfo);
    }
  },
  watch: {
    userInfo: function(newVal, oldVal) {
      this.getDefaultProgram(newVal);
    },
    currentChild: function(newVal, oldVal) {
      this.getDefaultProgram(this.userInfo);
    }
  },
  methods: {
    setColor(item) {
      return item > 0 ? "text-red-500" : "";
    },
    selectProgram() {
      if (hasValidRole(this.role, Role.Family)) {
        this.fetchData(this.currentChild.uuid, this.programId);
      } else {
        this.fetchData(this.userInfo.uuid, this.programId);
      }
    },
    async getDefaultProgram(userInfo) {
      let uuid = "";
      if (hasValidRole(this.role, Role.Family)) {
        uuid = this.currentChild.uuid;
        await this.fetchListProgram();
      } else {
        uuid = userInfo.uuid;
        userInfo.programs?.forEach(item => {
          return this.programs.push({ id: item.id, name: item.name });
        });
        this.programId = this.programs[0]?.id;
        this.select.options = this.programs;
      }

      this.fetchData(uuid, this.programId);
    },
    async fetchListProgram() {
      try {
        const res = await this.$axios.get(service_paths.programs, {
          limit: 1000
        });
        if (!res.data.data) return;
        this.programs = res.data.data?.filter(item =>
          this.currentChild.program_ids?.includes(item.id)
        );
        this.programId = this.programs[0]?.id;
        this.select.options = this.programs;
      } catch (error) {
        console.log(error);
      }
    },
    fetchData(uuid, programId) {
      if (!programId) return;
      return this.$axios
        .get(`${service_paths.user_academic_plan}/${uuid}/${programId}`)
        .then(response => {
          this.infoForm = response.data;
          this.programName =
            this.programs.find(item => item.id === this.programId)?.name ||
            "Program name";
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card {
  box-shadow: 0 1px 4px 0 #49494980;
}
.border-top-1 {
  border-top: 1px solid rgb(207, 205, 205);
}
.md-table-row:nth-child(2n) {
  background-color: rgb(248, 248, 248);
}
</style>
